import React from "react";
export const useOnScreen = (ref, opts = {}) => {
    const [isIntersecting, setIntersecting] = React.useState(false);
    const [isAboveViewport, setIsAboveViewport] = React.useState(false);
    React.useEffect(() => {
        if (!ref)
            return;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIntersecting(true);
                return;
            }
            setIntersecting(false);
            if (entry.boundingClientRect.top > 0) {
                setIsAboveViewport(false);
            }
            else {
                setIsAboveViewport(true);
            }
        }, opts);
        if (ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [opts, ref]);
    return [isIntersecting, isAboveViewport];
};
//# sourceMappingURL=use-on-screen.js.map